import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { READ_BUSINESS_PROFILE } from '../../../constants/eInvoicePermissions';

export default function BusinessProfileAccessLayout() {
  const { navbar } = useTranslatedMessages();

  return (
    <EInvoiceAccessLayout permission={READ_BUSINESS_PROFILE} title={navbar?.business_profiles ?? 'Business Profiles'} />
  );
}
